import React, { Fragment, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Checkbox from '@material-ui/core/Checkbox';
import { Text } from 'recharts';
import { Link, ListItem, Select } from '@material-ui/core';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import ValidationText from '../../components/atoms/ValidationText';
import ShopEditConfirm from './ShopEditConfirm';
import FileUpload from '../../components/molecules/FileUpload';
import {
  getShops,
  editShop,
  addShopImage,
  countShopEmail,
  getZipCode
} from '../../actions/Shop';
import { sendLogin, resizeImage, uploadFile } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import { getOptionCities } from '../../actions/Cities';
import { languages, languageType } from '../../constants/Language';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  descriptionSmall: {
    fontSize: '0.875rem',
    color: '#707070',
    margin: '10px 0px 0px'
  },
  subDescription: {
    fontSize: '0.875rem'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    }
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCell90: {
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  divider: {
    margin: '0px 0px 20px'
  },
  note: {
    padding: '10px'
  },
  tagCaution: {
    color: 'red',
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  textRed: {
    color: '#f00'
  },
  marginBottom10: {
    marginBottom: '10px'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      paddingTop: 0
    }
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  selectContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  select: {
    width: '300px'
  },
  disableInput: {
    backgroundColor: '#d9d9d9'
  },
  link: {
    textDecoration: 'underline'
  },
  font14: {
    fontSize: 14
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      prefectures: state.commons.prefectures,
      cities: state.cities.listCities,
      statuses: state.shops.statuses,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getShops,
          editShop,
          addShopImage,
          countShopEmail,
          getAccounts,
          getOptionCities,
          getZipCode
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopId', 'setShopId', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', ''),
  withState('cityIdError', 'setCityIdError', ''),
  withState('city', 'setCity', ''),
  withState('cityId', 'setCityId', ''),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('phone', 'setPhone', ''),
  withState('email', 'setEmail', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage1', 'setPreviewImage1', null),
  withState('image2', 'setImage2', null),
  withState('previewImage2', 'setPreviewImage2', null),
  withState('image3', 'setImage3', null),
  withState('previewImage3', 'setPreviewImage3', null),
  withState('image4', 'setImage4', null),
  withState('previewImage4', 'setPreviewImage4', null),
  withState('image5', 'setImage5', null),
  withState('previewImage5', 'setPreviewImage5', null),
  withState('stealthMode', 'setStealthMode', 'UNSTEALTH'),
  withState('stealthModeStr', 'setStealthModeStr', '表示'),
  withState('gochiRestriction', 'setGochiRestriction', 'ANY'),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', '制限なし'),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState('depositManageStr', 'setDepositManageStr', '入金を自身で管理する'),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  withState('status', 'setStatus', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('shopNameError', 'setShopNameError', ''),
  withState('shopNameKanaError', 'setShopNameKanaError', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('cityError', 'setCityError', ''),
  withState('addressError', 'setAddressError', ''),
  withState('contactPhoneError', 'setContactPhoneError', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('emailError', 'setEmailError', ''),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('shopCategoriesError', 'setShopCategoriesError', ''),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('snsFacebookError', 'setSnsFacebookError', ''),
  withState('snsTwitterError', 'setSnsTwitterError', ''),
  withState('snsInstagramError', 'setSnsInstagramError', ''),
  withState('shopContactNameError', 'setShopContactNameError', ''),
  withState('shopGroupNameError', 'setShopGroupNameError', ''),
  withState('departmentError', 'setDepartmentError', ''),
  withState('showPhone', 'setShowPhone', 1),
  withState('childShopFlag', 'setChildShopFlag', 0),
  withState('address1', 'setAddress1', ''),
  withState('address2', 'setAddress2', ''),
  withState('address1Error', 'setAddress1Error', ''),
  withState('address2Error', 'setAddress2Error', ''),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('allowMenuPriceShashoku', 'setAllowMenuPriceShashoku', 0),
  withState('bankCode', 'setBankCode', ''),
  withState('bankCodeError', 'setBankCodeError', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('bankBranchCodeError', 'setBankBranchCodeError', ''),
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('registrationIdError', 'setRegistrationIdError', ''),
  withState('groupRegistrationId', 'setGroupRegistrationId', 'T'),
  withState('paymentGroupId', 'setPaymentGroupId', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities();
      this.props.setShopId(this.props.editInput.shopId);
      this.props.setShopName(this.props.editInput.shopName);
      this.props.setShopNameKana(this.props.editInput.shopNameKana);
      this.props.setCountryCode(this.props.editInput.countryCode);
      this.props.setZipCode(this.props.editInput.zipCode);
      this.props.setPrefectureCode(this.props.editInput.prefectureCode);
      this.props.setCity(this.props.editInput.city);
      this.props.setAddress(this.props.editInput.address);
      this.props.setAddress1(this.props.editInput.address1);
      this.props.setAddress2(this.props.editInput.address2);
      this.props.setBuilding(this.props.editInput.building);
      this.props.setShopGroupName(this.props.editInput.shopGroupName);
      this.props.setShopContactName(this.props.editInput.shopContactName);
      this.props.setDepartment(this.props.editInput.department);
      this.props.setContactPhone(this.props.editInput.contactPhone);
      this.props.setPhone(this.props.editInput.phone);
      this.props.setEmail(this.props.editInput.email);
      this.props.setIntroduction(this.props.editInput.introduction);
      this.props.setBusinessHours(this.props.editInput.businessHours);
      this.props.setHoliday(this.props.editInput.holiday);
      this.props.setNearestStation(this.props.editInput.nearestStation);
      this.props.setPriceRange(this.props.editInput.priceRange);
      this.props.setAccess(this.props.editInput.access);
      this.props.setWebPage(this.props.editInput.webPage);
      this.props.setTags(this.props.editInput.tags);
      this.props.setTagStr(this.props.editInput.tagStr);
      if (typeof this.props.editInput.images[0] !== 'undefined') {
        this.props.setPreviewImage1(this.props.editInput.images[0].image);
      }
      if (typeof this.props.editInput.images[1] !== 'undefined') {
        this.props.setPreviewImage2(this.props.editInput.images[1].image);
      }
      if (typeof this.props.editInput.images[2] !== 'undefined') {
        this.props.setPreviewImage3(this.props.editInput.images[2].image);
      }
      if (typeof this.props.editInput.images[3] !== 'undefined') {
        this.props.setPreviewImage4(this.props.editInput.images[3].image);
      }
      if (typeof this.props.editInput.images[4] !== 'undefined') {
        this.props.setPreviewImage5(this.props.editInput.images[4].image);
      }
      this.props.setStealthMode(this.props.editInput.stealthMode);
      this.props.setStealthModeStr(this.props.editInput.stealthModeStr);
      this.props.setGochiRestriction(this.props.editInput.gochiRestriction);
      this.props.setGochiRestrictionStr(
        this.props.editInput.gochiRestrictionStr
      );
      this.props.setDepositManage(
        this.props.editInput.accountStatus.stripeAccount
          ? 'SELF'
          : this.props.editInput.depositManage
      );
      this.props.setDepositManageStr(
        this.props.editInput.accountStatus.stripeAccount
          ? 'Stripe経由で受取（週1回入金）'
          : this.props.editInput.depositManageStr
      );
      this.props.setCashAllowed(this.props.editInput.cashAllowed);
      this.props.setAllowMenuPriceShashoku(
        this.props.editInput.shopDetail &&
          this.props.editInput.shopDetail.allowMenuPriceShashoku
      );
      this.props.setBankName(this.props.editInput.bankName);
      this.props.setBankBranchName(this.props.editInput.bankBranchName);
      this.props.setBankAccountType(
        this.props.editInput.bankAccountType === null
          ? 'SAVINGS'
          : this.props.editInput.bankAccountType
      );
      this.props.setBankAccountTypeStr(
        this.props.editInput.bankAccountTypeStr === null
          ? '普通預金'
          : this.props.editInput.bankAccountTypeStr
      );
      this.props.setBankAccountNumber(this.props.editInput.bankAccountNumber);
      this.props.setBankAccountHolder(this.props.editInput.bankAccountHolder);
      this.props.setStatus(this.props.editInput.status);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.setShopCategoryId(this.props.editInput.shopCategoryId);
      this.props.setNumberSit(this.props.editInput.numberSit);
      this.props.setParking(this.props.editInput.parking);
      this.props.setSmoking(this.props.editInput.smoking);
      this.props.setSnsFacebook(this.props.editInput.snsFacebook);
      this.props.setSnsTwitter(this.props.editInput.snsTwitter);
      this.props.setSnsInstagram(this.props.editInput.snsInstagram);
      if (this.props.editInput.showPhone) {
        this.props.setShowPhone(1);
      } else {
        this.props.setShowPhone(0);
      }
      if (
        this.props.editInput.childShopFlag &&
        this.props.editInput.childShopFlag === 1
      ) {
        this.props.setChildShopFlag(1);
      } else {
        this.props.setChildShopFlag(0);
      }
      this.props.setBankCode(this.props.editInput.bankCode);
      this.props.setBankBranchCode(this.props.editInput.bankBranchCode);
      this.props.setPaymentGroupId(this.props.editInput.paymentGroupId);
      if (this.props.editInput.paymentGroupId) {
        this.props.setRegistrationId(this.props.editInput.registrationId);
        if (this.props.editInput.groupRegistrationId) {
          this.props.setHaveRegistrationId(1);
          this.props.setGroupRegistrationId(
            this.props.editInput.groupRegistrationId
          );
        } else {
          this.props.setHaveRegistrationId(0);
          this.props.setGroupRegistrationId(null);
        }
      } else {
        this.props.setGroupRegistrationId(null);
        if (this.props.editInput.registrationId) {
          this.props.setHaveRegistrationId(1);
          this.props.setRegistrationId(this.props.editInput.registrationId);
        } else {
          this.props.setHaveRegistrationId(0);
          this.props.setRegistrationId('T');
        }
      }

      const chosenCityNameList = [];
      this.props.cities
        .filter(
          item => item.cityName && item.cityName === this.props.editInput.city
        )
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        this.props.setCityId(Number(chosenCityNameList[0].value));
      }

      let dataFirst = {};
      const origilData = {
        shopName: null,
        shopNameKana: null,
        address1: null,
        address2: null,
        building: null,
        shopGroupName: null,
        shopContactName: null,
        department: null,
        introduction: null,
        businessHours: null,
        holiday: null,
        nearestStation: null,
        access: null,
        numberSit: null,
        smoking: null,
        parking: null,
        zipCode: null,
        prefectureCode: null,
        city: null,
        cityId: null,
        contactPhone: null,
        phone: null,
        email: null,
        priceRange: null,
        webPage: null,
        tags: null,
        stealthMode: null,
        gochiRestriction: null,
        depositManage: null,
        bankAccount: null,
        status: null,
        updatedAt: null,
        shopCategoryId: null,
        snsFacebook: null,
        snsTwitter: null,
        snsInstagram: null,
        showPhone: null,
        childShopFlag: null,
        countryCode: null,
        cashAllowed: null,
        registrationId: null
      };
      dataFirst = origilData;
      if (this.props.editInput.otherLanguages) {
        const str = JSON.stringify(this.props.editInput.otherLanguages);
        dataFirst.otherLanguages = JSON.parse(str);
      }
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) return;
        const translatedData = dataFirst.otherLanguages.find(
          el => el.language === item.value
        );
        if (!translatedData) {
          const other = {
            translateType: 0,
            language: item.value
          };
          dataFirst.otherLanguages.push(other);
        }
      });
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    searchKey,
    editInput,
    prefectures,
    openEditConfirm,
    updateOpenEditConfirm,
    openEditProgress,
    updateOpenEditProgress,
    loading,
    updateLoading,
    isEditSuccess,
    updateIsEditSuccess,
    resultMessage,
    setResultMessage,
    shopId,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    countryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity,
    // address,
    // setAddress,
    address1,
    setAddress1,
    address2,
    // setAddress2,
    cityId,
    setCityId,
    // cityName,
    // setCityName,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    contactPhone,
    setContactPhone,
    phone,
    setPhone,
    email,
    setEmail,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    priceRange,
    setPriceRange,
    access,
    setAccess,
    webPage,
    setWebPage,
    tagStr,
    setTagStr,
    tags,
    setTags,
    image1,
    setImage1,
    previewImage1,
    setPreviewImage1,
    image2,
    setImage2,
    previewImage2,
    setPreviewImage2,
    image3,
    setImage3,
    previewImage3,
    setPreviewImage3,
    image4,
    setImage4,
    previewImage4,
    setPreviewImage4,
    image5,
    setImage5,
    previewImage5,
    setPreviewImage5,
    stealthMode,
    setStealthMode,
    stealthModeStr,
    setStealthModeStr,
    gochiRestriction,
    setGochiRestriction,
    gochiRestrictionStr,
    setGochiRestrictionStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    status,
    updatedAt,
    updateOpenEditModal,
    shopCategories,
    shopCategoryId,
    setShopCategoryId,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    snsFacebook,
    setSnsFacebook,
    setSnsTwitter,
    snsTwitter,
    setSnsInstagram,
    snsInstagram,
    shopNameError,
    setShopNameError,
    shopNameKanaError,
    setShopNameKanaError,
    zipCodeError,
    setZipCodeError,
    cityError,
    // setCityError,
    // addressError,
    // setAddressError,
    // cityError,
    // setCityError,
    cityIdError,
    setCityIdError,
    contactPhoneError,
    setContactPhoneError,
    phoneError,
    setPhoneError,
    emailError,
    setEmailError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    shopCategoriesError,
    setShopCategoriesError,
    snsFacebookError,
    setSnsFacebookError,
    snsTwitterError,
    setSnsTwitterError,
    snsInstagramError,
    setSnsInstagramError,
    shopContactNameError,
    shopGroupNameError,
    departmentError,
    setShopContactNameError,
    setShopGroupNameError,
    setDepartmentError,
    showPhone,
    setShowPhone,
    childShopFlag,
    setChildShopFlag,
    address1Error,
    setAddress1Error,
    // address2Error,
    // setAddress2Error,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType,
    cashAllowed,
    // setCashAllowed,
    allowMenuPriceShashoku,
    setAllowMenuPriceShashoku,
    bankCode,
    setBankCode,
    bankCodeError,
    setBankCodeError,
    listBank,
    bankBranchCode,
    setBankBranchCode,
    bankBranchCodeError,
    setBankBranchCodeError,
    listBankBranch,
    haveRegistrationId,
    setHaveRegistrationId,
    registrationId,
    setRegistrationId,
    registrationIdError,
    setRegistrationIdError,
    groupRegistrationId,
    paymentGroupId
  }) => {
    const bankAccount = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder,
      bankCode,
      bankBranchCode
    };

    const otherData = {
      tagStr,
      previewImage1,
      previewImage2,
      previewImage3,
      previewImage4,
      previewImage5,
      stealthModeStr,
      gochiRestrictionStr,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      shopCategories,
      bankCode,
      bankBranchCode
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        shopName,
        shopNameKana,
        address1,
        address2,
        building,
        shopGroupName,
        shopContactName,
        department,
        introduction,
        businessHours,
        holiday,
        nearestStation,
        access,
        numberSit,
        smoking,
        parking,

        zipCode,
        prefectureCode,
        city,
        cityId,
        contactPhone,
        phone,
        email,
        priceRange,
        webPage,
        tags,
        stealthMode,
        gochiRestriction,
        depositManage,
        bankAccount,
        status,
        updatedAt,
        shopCategoryId,
        snsFacebook,
        snsTwitter,
        snsInstagram,
        showPhone,
        childShopFlag,
        countryCode,
        cashAllowed,
        shopDetail: {
          shopDetailId:
            editInput.shopDetail && editInput.shopDetail.shopDetailId,
          allowMenuPriceShashoku
        },
        isShopCanEditSetting: editInput.isShopCanEditSetting,
        registrationId:
          haveRegistrationId || paymentGroupId ? registrationId : undefined,
        groupRegistrationId,
        haveRegistrationId,
        paymentGroupId
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          shopName,
          shopNameKana,
          shopGroupName,
          shopContactName,
          department,
          introduction,
          businessHours,
          holiday,
          nearestStation,
          access,
          numberSit,
          smoking,
          parking
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    // setting language
    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setShopName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.shopName
                ? multiLangData.otherLanguages[k].params.shopName
                : ''
            );
            setShopNameKana(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.shopNameKana
                ? multiLangData.otherLanguages[k].params.shopNameKana
                : ''
            );
            setShopGroupName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.shopGroupName
                ? multiLangData.otherLanguages[k].params.shopGroupName
                : ''
            );
            setShopContactName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.shopContactName
                ? multiLangData.otherLanguages[k].params.shopContactName
                : ''
            );
            setDepartment(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.department
                ? multiLangData.otherLanguages[k].params.department
                : ''
            );
            setIntroduction(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.introduction
                ? multiLangData.otherLanguages[k].params.introduction
                : ''
            );
            setBusinessHours(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.businessHours
                ? multiLangData.otherLanguages[k].params.businessHours
                : ''
            );
            setHoliday(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.holiday
                ? multiLangData.otherLanguages[k].params.holiday
                : ''
            );
            setNearestStation(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.nearestStation
                ? multiLangData.otherLanguages[k].params.nearestStation
                : ''
            );
            setAccess(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.access
                ? multiLangData.otherLanguages[k].params.access
                : ''
            );
            setNumberSit(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.numberSit
                ? multiLangData.otherLanguages[k].params.numberSit
                : ''
            );
            setSmoking(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.smoking
                ? multiLangData.otherLanguages[k].params.smoking
                : ''
            );
            setParking(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.parking
                ? multiLangData.otherLanguages[k].params.parking
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        setShopName(multiLangData.shopName);
        setShopNameKana(multiLangData.shopNameKana);
        setShopGroupName(multiLangData.shopGroupName);
        setShopContactName(multiLangData.shopContactName);
        setDepartment(multiLangData.department);
        setIntroduction(multiLangData.introduction);
        setBusinessHours(multiLangData.businessHours);
        setHoliday(multiLangData.holiday);
        setNearestStation(multiLangData.nearestStation);
        setAccess(multiLangData.access);
        setNumberSit(multiLangData.numberSit);
        setSmoking(multiLangData.smoking);
        setParking(multiLangData.parking);
      }
      setIsLanguage(v);
      setMultiLangData(data);
    };

    const errors = {
      shopNameError,
      shopNameKanaError,
      zipCodeError,
      cityError,
      // addressError,
      address1Error,
      // address2Error,
      // cityError,
      cityIdError,
      contactPhoneError,
      phoneError,
      emailError,
      bankAccountNumberError,
      bankAccountHolderError,
      shopCategoriesError,
      snsFacebookError,
      snsTwitterError,
      snsInstagramError,
      shopContactNameError,
      shopGroupNameError,
      departmentError,
      bankCodeError,
      bankBranchCodeError,
      registrationIdError
    };
    const enableShopBank =
      editInput.bankSwitchable || !editInput.paymentGroupType;

    const checkCityName = () => {
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    useEffect(() => {
      setCityId(checkCityName());
    }, [city]);

    const setNewCityId = newCity => {
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === newCity)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        setCityId(Number(chosenCityNameList[0].value));
      }
    };

    const getZipCodeData = async zipcode => {
      await actions.getZipCode(zipcode).then(data => {
        setPrefectureCode(data.payload.prefectureCode);
        setCity(data.payload.city ? data.payload.city : 0);
        // setAddress(data.payload.address ? data.payload.address : '');
        setAddress1(data.payload.address1 ? data.payload.address1 : '');
        // setAddress2(data.payload.address2 ? data.payload.address2 : '');
        setNewCityId(data.payload.city);
      });
    };

    const validShopName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = shopName;
      if (value.trim() === '') {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopName(value);
      return 0;
    };
    const validShopNameKana = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = shopNameKana;
      if (value.trim() === '') {
        setShopNameKanaError('必須項目です。');
        return 1;
      }
      if (
        !/^[\u3040-\u309F\s\d０-９ー]+$/.test(value) &&
        isLanguage === languageType.ORIGIN
      ) {
        setShopNameKanaError('ひらがなで入力してください。');
        return 1;
      }
      setShopNameKanaError('');
      setShopNameKana(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    const validShopCategories = () => {
      const value = shopCategoryId;
      if (value === 0) {
        setShopCategoriesError('必須項目です。');
        return 1;
      }
      setShopCategoriesError('');
      setShopCategoryId(value);
      return 0;
    };
    const validSnsFacebook = () => {
      const value = snsFacebook;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsFacebookError('URLを入力してください');
        return 1;
      }
      setSnsFacebookError('');
      setSnsFacebook(value);
      return 0;
    };
    const validSnsTwitter = () => {
      const value = snsTwitter;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsTwitterError('URLを入力してください');
        return 1;
      }
      setSnsTwitterError('');
      setSnsTwitter(value);
      return 0;
    };
    const validSnsInstagram = () => {
      const value = snsInstagram;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsInstagramError('URLを入力してください');
        return 1;
      }
      setSnsInstagramError('');
      setSnsInstagram(value);
      return 0;
    };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      setCityId(value);
      return 0;
    };
    // const validAddress = () => {
    //   const value = address ? address.trim() : '';
    //   if (value === '') {
    //     setAddressError('必須項目です。');
    //     return 1;
    //   }
    //   setAddressError('');
    //   setAddress(value);
    //   return 0;
    // };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validAddress1 = () => {
      const value = address1 ? address1.trim() : '';
      if (value === '') {
        setAddress1Error('必須項目です。');
        return 1;
      }
      setAddress1Error('');
      setAddress1(value);
      return 0;
    };
    // const validAddress2 = () => {
    //  const value = address2 ? address2.trim() : '';
    //  if (value === '') {
    //    setAddress2Error('必須項目です。');
    //    return 1;
    //  }
    //  setAddress2Error('');
    //  setAddress2(value);
    //  return 0;
    // };
    const validShopContactName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = shopContactName ? shopContactName.trim() : '';
      if (value === '') {
        setShopContactNameError('必須項目です。');
        return 1;
      }
      setShopContactNameError('');
      setShopContactName(value);
      return 0;
    };
    const validShopGroupName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = shopGroupName ? shopGroupName.trim() : '';
      if (value === '') {
        setShopGroupNameError('必須項目です。');
        return 1;
      }
      setShopGroupNameError('');
      setShopGroupName(value);
      return 0;
    };
    const validDepartment = () => {
      const value = department ? department.trim() : '';
      if (value === '') {
        setDepartmentError('必須項目です。');
        return 1;
      }
      setDepartmentError('');
      setDepartment(value);
      return 0;
    };
    const validContactPhone = () => {
      const value = contactPhone;
      if (value === '') {
        setContactPhoneError('必須項目です。');
        return 1;
      }
      if (value && !/^\d+$/.test(value)) {
        setContactPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setContactPhoneError('');
      setContactPhone(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone;
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validEmail = () => {
      const value = email;
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validEmailCount = emailData => {
      const value = email;
      if (
        emailData.payload.totalCount > 0 &&
        editInput.email !== emailData.payload.shops[0].email
      ) {
        setEmailError('メールアドレスが既に登録されています。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };

    const validBankAccountNumber = () => {
      const value = bankAccountNumber;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (!/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      if (enableShopBank && depositManage === 'SELF') {
        if (
          !value &&
          ((bankName && bankName !== '') ||
            (bankBranchName && bankBranchName !== '') ||
            (bankAccountHolder && bankAccountHolder !== ''))
        ) {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (value && !/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };

    const validBankAccountHolder = () => {
      const value = bankAccountHolder;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      if (enableShopBank && depositManage === 'SELF') {
        if (
          !value &&
          ((bankName && bankName !== '') ||
            (bankBranchName && bankBranchName !== '') ||
            (bankAccountNumber && bankAccountNumber !== ''))
        ) {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          value &&
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };

    const validRegistrationId = () => {
      const value = registrationId;
      if (paymentGroupId) {
        return 0;
      }
      if (haveRegistrationId === 1) {
        const valueNumber = value.slice(1);
        if (!value || !valueNumber) {
          setRegistrationIdError('必須項目です。');
          return 1;
        }
        if (!/^\d+$/.test(valueNumber)) {
          setRegistrationIdError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueNumber.length !== 13) {
          setRegistrationIdError('13桁の番号をご入力ください。');
          return 1;
        }
      }
      setRegistrationId(value);
      setRegistrationIdError('');
      return 0;
    };

    const getBankName = bankCodeValue => {
      let listBankName = [];
      listBankName = listBank.filter(bank => bank.bankCode === bankCodeValue);
      if (listBankName.length === 0) {
        setBankCodeError('データが正しくありません。');
        setBankName('');
        return false;
      }
      setBankName(listBankName[0].bankName);
      return true;
    };

    const getBankBranchName = bankBranchCodeValue => {
      let listBankBranchName = [];
      listBankBranchName = listBankBranch.filter(
        bankBranch => bankBranch.uniqueCode === bankCode + bankBranchCodeValue
      );
      if (listBankBranchName.length === 0) {
        setBankBranchCodeError('データが正しくありません。');
        setBankBranchName('');
        return false;
      }
      setBankBranchName(listBankBranchName[0].bankBranchName);
      return true;
    };

    const validBankCode = () => {
      const value = bankCode;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 4) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankName(value)) {
          return 1;
        }
      }
      if (
        enableShopBank &&
        depositManage === 'SELF' &&
        ((bankBranchCode && bankBranchCode !== '') ||
          (bankAccountNumber && bankAccountNumber !== '') ||
          (bankAccountHolder && bankAccountHolder !== ''))
      ) {
        if (!value) {
          setBankCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 4) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankName(value)) {
          return 1;
        }
      }
      setBankCodeError('');
      return 0;
    };

    const validBankBranchCode = () => {
      const value = bankBranchCode;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankBranchCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 3) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankBranchName(value)) {
          return 1;
        }
      }
      if (
        enableShopBank &&
        depositManage === 'SELF' &&
        ((bankCode && bankCode !== '') ||
          (bankAccountNumber && bankAccountNumber !== '') ||
          (bankAccountHolder && bankAccountHolder !== ''))
      ) {
        if (!value) {
          setBankBranchCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 3) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankBranchName(value)) {
          return 1;
        }
      }
      setBankBranchCodeError('');
      return 0;
    };

    const convertShowPhone = checked => {
      if (checked) {
        setShowPhone(0);
      } else {
        setShowPhone(1);
      }
    };
    const convertChildShopFlag = checked => {
      if (checked) {
        setChildShopFlag(1);
      } else {
        setChildShopFlag(0);
      }
    };
    const valid = emailData => {
      let errorCount =
        validShopName() +
        validShopNameKana() +
        validCityId() +
        validZipCodeSubmit() +
        // validCity() +
        // validAddress() +
        validAddress1() +
        // validAddress2() +
        validContactPhone() +
        validPhone() +
        validEmail() +
        validBankAccountNumber() +
        validBankAccountHolder() +
        validShopCategories() +
        validSnsFacebook() +
        validSnsTwitter() +
        validSnsInstagram() +
        validShopContactName() +
        validShopGroupName() +
        validDepartment() +
        validBankCode() +
        validBankBranchCode() +
        validRegistrationId();
      if (emailData) errorCount += validEmailCount(emailData);
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertImages = () => {
      const imageArray = {
        0: {
          image: image1,
          imagePath: previewImage1
        },
        1: {
          image: image2,
          imagePath: previewImage2
        },
        2: {
          image: image3,
          imagePath: previewImage3
        },
        3: {
          image: image4,
          imagePath: previewImage4
        },
        4: {
          image: image5,
          imagePath: previewImage5
        }
      };
      return imageArray;
    };
    const convertStealthModeStr = mode => {
      if (mode === 'UNSTEALTH') {
        setStealthModeStr('表示');
      } else {
        setStealthModeStr('非表示');
      }
    };
    const convertGochiRestrictionStr = mode => {
      if (mode === 'MENTION_ONLY') {
        setGochiRestrictionStr('指名ごちのみ');
      } else {
        setGochiRestrictionStr('制限なし');
      }
    };
    const convertDepositManageStr = mode => {
      if (mode === 'SELF') {
        setDepositManageStr('Stripe経由で受取（週1回入金）');
      } else {
        setDepositManageStr('銀行口座で直接受取（月1回入金）（オプション）');
      }
    };
    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };
    const cancelAction = () => updateOpenEditModal(false);
    const confirmAction = async () => {
      const emailData = await actions
        .countShopEmail(email)
        .then(data => checkSession(data));
      if (!valid(emailData)) {
        alert('登録情報を正しく入力してください。');
      } else {
        setCityNameData(cityId);
        updateOpenEditConfirm(true);
        setMultiLangData(getCurrentData());
      }
    };
    const backAction = () => updateOpenEditConfirm(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenEditProgress(true);
      const images = convertImages();
      const editedShop = await actions
        .editShop(shopId, multiLangData)
        .then(data => checkSession(data));
      const imagePaths = await Promise.all(
        Object.keys(images).map(async i => {
          if (images[i].image !== null) {
            let { image } = images[i];
            if (image.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
              const { resizeImageFile } = await resizeImage(image);
              image = resizeImageFile;
            }
            const imagePath = await uploadFile('shop', shopId, image, 'public');
            return imagePath;
          }
          if (images[i].imagePath !== null) {
            return images[i].imagePath;
          }
          return null;
        })
      );
      const addImages = imagePaths
        .filter(i => i !== null)
        .map((i, index) => {
          return { image: i, viewOrder: index };
        });
      if (Object.keys(addImages).length !== 0) {
        await actions
          .addShopImage(shopId, {
            images: addImages
          })
          .then(data => checkSession(data));
      }
      if (editedShop.type === 'EDIT_SHOP_SUCCESS') {
        updateIsEditSuccess(true);
        actions.getShops(searchKey).then(data => {
          actions.getAccounts({ cognitoUserId: '' });
          checkSession(data);
        });
        setResultMessage('編集が完了しました。');
        updateLoading(false);
      } else {
        updateIsEditSuccess(false);
        if (editedShop.payload.status && editedShop.payload.status === 409) {
          setResultMessage(
            'こども食堂用（単独）が存在していますのでこども食堂の設定が外せません。'
          );
        } else {
          setResultMessage('編集に失敗しました。');
        }
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isEditSuccess) {
        updateOpenEditModal(false);
        updateOpenEditConfirm(false);
        updateOpenEditProgress(false);
      } else {
        updateOpenEditProgress(false);
      }
    };

    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };

    const handleChangeCity = (e, v) => {
      setCity(v.label);
      setCityId(e);
    };

    const handleChangeBankCode = value => {
      setBankCode(value);
      setBankName('');
      setBankBranchCode('');
      setBankBranchName('');
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">店舗編集</Typography>
        </div>
        <div className={classes.selectContainer}>
          <Select
            className={`${classes.textField} ${classes.select}`}
            value={isLanguage}
            onChange={e => {
              if (isLanguage === e.target.value) {
                return;
              }
              if (
                valid() ||
                (isLanguage !== languageType.ORIGIN && translateType === 0)
              ) {
                setLanguage(e.target.value);
              } else {
                alert('登録情報を正しく入力してください。');
              }
            }}
          >
            {languages.map(lang => (
              <MenuItem key={lang.value} value={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
        </div>

        {isLanguage !== languageType.ORIGIN && (
          <ListItem className={classes.itemForm}>
            <Typography component="div" className={classes.formInput}>
              <RadioGroup
                value={translateType}
                onChange={e => {
                  setTranslateType(parseInt(e.target.value, 10));
                }}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio color="primary" />}
                  label="GG翻訳を選択"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary" />}
                  label="自分で文章入力"
                />
              </RadioGroup>
            </Typography>
          </ListItem>
        )}
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <RequiredButton />
              </TableCell>
              <TableCell className={[classes.tableCell90, classes.colRight]}>
                <TextField
                  required
                  label="店舗名"
                  defaultValue={editInput.shopName}
                  placeholder="ごち屋　天神店"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 250 : 1000
                  }}
                  value={shopName}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                  onBlur={validShopName}
                />
                {(isLanguage === languageType.ORIGIN ||
                  translateType === 1) && (
                  <ValidationText message={errors.shopNameError} />
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  required
                  label="店舗名かな"
                  defaultValue={editInput.shopNameKana}
                  placeholder="ごちや　てんじんてん"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setShopNameKana(e.target.value);
                  }}
                  onBlur={validShopNameKana}
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 250 : 1000
                  }}
                  value={shopNameKana}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
                {(isLanguage === languageType.ORIGIN ||
                  translateType === 1) && (
                  <ValidationText message={errors.shopNameKanaError} />
                )}
              </TableCell>
            </TableRow>
            {isLanguage === languageType.ORIGIN && (
              <TableRow className={classes.groupBorderNone}>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="郵便番号"
                    defaultValue={editInput.zipCode}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setZipCode(e.target.value);
                    }}
                    onBlur={validZipCode}
                  />
                  <Typography variant="h7">
                    ハイフンなしで記載ください
                  </Typography>
                  <ValidationText message={errors.zipCodeError} />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow className={classes.tableRowBorderNone}>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.hideMobile]}
                />
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    select
                    label="都道府県"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    value={prefectureCode}
                    onChange={e => {
                      setPrefectureCode(e.target.value);
                      setCityId(Number(0));
                      setCity('');
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  >
                    {prefectures.map(item => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow className={classes.tableRowBorderNone}>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.hideMobile]}
                />
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  {prefectureCode > 0 && (
                    <ReactSelectMaterialUi
                      required
                      label="市区町村*"
                      fullWidth
                      className={classes.textField}
                      defaultValue={String(checkCityName())}
                      value={String(cityId)}
                      options={getCitiesOptions()}
                      margin="normal"
                      onChange={handleChangeCity}
                      SelectProps={{
                        isClearable: true,
                        msgNoOptionsMatchFilter:
                          '名前が部分一致する店舗がありません'
                      }}
                      onBlur={validCityId}
                    />
                  )}
                  {editInput.city && !cityId && checkCityName() <= 0 && (
                    <Typography variant="h7">
                      市区町村はまだ正規化されません。再度設定してください。
                    </Typography>
                  )}
                  {(!prefectureCode || prefectureCode <= 0) && (
                    <ReactSelectMaterialUi
                      disabled
                      required
                      fullWidth
                      label="市区町村*"
                      className={classes.textField}
                      defaultValue={String(checkCityName())}
                      value={String(cityId)}
                      options={getCitiesOptions()}
                      margin="normal"
                      onChange={handleChangeCity}
                      SelectProps={{
                        isClearable: true,
                        msgNoOptionsMatchFilter:
                          '名前が部分一致する店舗がありません'
                      }}
                      onBlur={validCityId}
                    />
                  )}
                  <ValidationText message={errors.cityIdError} />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.hideMobile]}
                />
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="町域・番地"
                    placeholder="天神"
                    defaultValue={editInput.address1}
                    value={address1}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setAddress1(e.target.value);
                    }}
                    onBlur={validAddress1}
                    inputProps={{
                      maxLength: 250
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.address1Error} />
                  )}
                </TableCell>
              </TableRow>
            )}
            {/* {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.hideMobile]}
                />
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="番地"
                    placeholder="1-2-3"
                    defaultValue={editInput.address2}
                    value={address2}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setAddress2(e.target.value);
                    }}
                    onBlur={validAddress2}
                    inputProps={{
                      maxLength: 250
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.address2Error} />
                  )}
                </TableCell>
              </TableRow>
            )} */}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.hideMobile} />
                <TableCell className={classes.colRight}>
                  <TextField
                    label="建物名"
                    defaultValue={editInput.building}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBuilding(e.target.value);
                    }}
                    value={building}
                    inputProps={{
                      maxLength: 250
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    select
                    label="店舗カテゴリー"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    value={shopCategoryId}
                    onChange={e => {
                      setShopCategoryId(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  >
                    {shopCategories.map(item => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </TableCell>
              </TableRow>
            )}
            {roles.isSecretariat && isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Fragment>
                    <FormControlLabel
                      checked={childShopFlag}
                      control={<Checkbox id="childShopFlag" color="primary" />}
                      label="こども食堂設定"
                      value={childShopFlag}
                      onChange={e => {
                        setChildShopFlag(e.target.checked);
                        convertChildShopFlag(e.target.checked);
                      }}
                    />
                  </Fragment>
                  <ValidationText message={errors.phoneError} />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  店舗オーナーさまへの依頼）
                  <br />
                  店舗オーナーさまが登録された店舗の現場に連絡しても、
                  「ごちめし」のことを全く知らないという事例が発生してきています。
                  店舗登録時には現場の責任者に了解を取った後に登録ください
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell
                className={[classes.tableCellBorderNone, classes.hideMobile]}
              />
              <TableCell
                className={[classes.tableCellBorderNone, classes.colRight]}
              >
                <TextField
                  required
                  label="運営会社名"
                  value={shopGroupName}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setShopGroupName(e.target.value);
                  }}
                  onBlur={validShopGroupName}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
                <Typography variant="h7">
                  個人店の場合は「なし」と記載ください
                </Typography>
                {(isLanguage === languageType.ORIGIN ||
                  translateType === 1) && (
                  <ValidationText message={errors.shopGroupNameError} />
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={[classes.tableCellBorderNone, classes.hideMobile]}
              />
              <TableCell
                className={[classes.tableCellBorderNone, classes.colRight]}
              >
                <TextField
                  required
                  label="ご担当者名"
                  value={shopContactName}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setShopContactName(e.target.value);
                  }}
                  onBlur={validShopContactName}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
                <ValidationText message={errors.shopContactNameError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={[classes.tableCellBorderNone, classes.hideMobile]}
              />
              <TableCell
                className={[classes.tableCellBorderNone, classes.colRight]}
              >
                <TextField
                  required
                  label="所属部署"
                  value={department}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setDepartment(e.target.value);
                  }}
                  onBlur={validDepartment}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
                <Typography variant="h7">
                  個人店の場合は「なし」と記載ください
                </Typography>
                <ValidationText message={errors.departmentError} />
              </TableCell>
            </TableRow>
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.hideMobile} />
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    label="電話番号（担当者）"
                    defaultValue={editInput.contactPhone}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setContactPhone(e.target.value);
                    }}
                    onBlur={validContactPhone}
                  />
                  <Typography variant="h7">
                    ハイフンなしで記載ください
                  </Typography>
                  <ValidationText message={errors.contactPhoneError} />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    label="店舗電話番号"
                    defaultValue={editInput.phone}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setPhone(e.target.value);
                    }}
                    onBlur={validPhone}
                  />
                  <Typography variant="h7">
                    ハイフンなしで記載ください
                  </Typography>
                  {!roles.isShop && (
                    <Fragment>
                      <br />
                      <FormControlLabel
                        checked={!showPhone}
                        control={<Checkbox id="showPhone" color="primary" />}
                        label="電話番号を非表示します。"
                        value={showPhone}
                        onChange={e => {
                          setShowPhone(e.target.checked);
                          convertShowPhone(e.target.checked);
                        }}
                      />
                    </Fragment>
                  )}
                  <ValidationText message={errors.phoneError} />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && !paymentGroupId && (
              <>
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <Typography>インボイス制度 適格事業者登録*</Typography>
                    <RadioGroup
                      row
                      value={haveRegistrationId}
                      onChange={e => {
                        setHaveRegistrationId(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="未登録"
                        disabled={paymentGroupId}
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="登録済み"
                        disabled={paymentGroupId}
                      />
                    </RadioGroup>
                  </TableCell>
                </TableRow>
                {haveRegistrationId === 1 && (
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        required
                        label="適格事業者登録番号"
                        className={classes.textField}
                        onChange={e => {
                          if (e.target.value[0] === 'T') {
                            setRegistrationId(e.target.value);
                          } else if (!e.target.value) {
                            setRegistrationId('T');
                          }
                        }}
                        value={
                          paymentGroupId ? groupRegistrationId : registrationId
                        }
                        onBlur={validRegistrationId}
                        disabled={paymentGroupId}
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                      />
                      <ValidationText message={errors.registrationIdError} />
                      <Typography variant="h7">
                        Tの後に続く13桁の番号を入力してください。
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="メールアドレス"
                    defaultValue={editInput.email}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    InputProps={{
                      readOnly: true
                    }}
                    onChange={e => {
                      setEmail(e.target.value);
                    }}
                    onBlur={validEmail}
                  />
                  <ValidationText message={errors.emailError} />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.hideMobile} />
                <TableCell className={classes.colRight}>
                  メールアドレスは、ごちめしの各種ご連絡、および、管理システムのIDとしても利用いたします。
                  メールアドレスの変更を行いたい場合には、画面右上のメニュー(人マーク)の「メールアドレス変更」より行ってください。
                  <br />
                  <Text className={classes.textRed}>
                    注意：管理者の方は「店舗情報管理」画面よりご変更可能です。
                  </Text>
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="店舗概要"
                  placeholder="創業年、お店の特徴、雰囲気　など"
                  fullWidth
                  multiline
                  rows="4"
                  value={introduction}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setIntroduction(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="営業時間"
                  placeholder="平日11：00～14：00 （LO 13：30）/土日祝11：00～14：00 （LO 13：30）"
                  value={businessHours}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setBusinessHours(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="定休日"
                  placeholder="第2・第4土曜、日曜、祝日"
                  value={holiday}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setHoliday(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
            </TableRow>
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="価格帯"
                    placeholder="○○～○○円"
                    defaultValue={editInput.priceRange}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setPriceRange(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="最寄り駅"
                  placeholder="○○線○○駅"
                  value={nearestStation}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setNearestStation(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="アクセス"
                  placeholder="（交通手段、最寄り駅など）より○○分"
                  value={access}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setAccess(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
            </TableRow>
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="WebページURL"
                    defaultValue={editInput.webPage}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setWebPage(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <AnyButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    label="タグ"
                    defaultValue={editInput.tagStr}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setTagStr(e.target.value);
                      splitTagStr(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.hideMobile} />
                <TableCell className={classes.colRight}>
                  #イタリアン #飲み会に #港区 など、半角の#をつけて
                  <span className={classes.tagCaution}>
                    スペースで区切ってください。
                  </span>
                  <br />
                  店舗のカテゴリー・特徴・売りなどをこちらのタグで表現して頂きます。
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <AnyButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <FileUpload
                    label="image1"
                    setFile={setImage1}
                    previewImage={previewImage1}
                    setPreviewImage={setPreviewImage1}
                  />
                  <FileUpload
                    label="image2"
                    setFile={setImage2}
                    previewImage={previewImage2}
                    setPreviewImage={setPreviewImage2}
                  />
                  <FileUpload
                    label="image3"
                    setFile={setImage3}
                    previewImage={previewImage3}
                    setPreviewImage={setPreviewImage3}
                  />
                  <FileUpload
                    label="image4"
                    setFile={setImage4}
                    previewImage={previewImage4}
                    setPreviewImage={setPreviewImage4}
                  />
                  <FileUpload
                    label="image5"
                    setFile={setImage5}
                    previewImage={previewImage5}
                    setPreviewImage={setPreviewImage5}
                  />
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.hideMobile} />
                <TableCell className={classes.colRight}>
                  画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。
                  <br />
                  店舗一覧には１番目に登録した画像が表示されます。
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <div className={classes.margin}>
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item>
                        <CardMedia
                          component="img"
                          alt="Facebook"
                          height="24"
                          image="/images/icon_facebook.png"
                          title="Facebook"
                          className={[
                            classes.marginBottom10,
                            classes.hideMobile
                          ]}
                        />
                      </Grid>
                      <Grid item xs={12} sm container>
                        <TextField
                          label="Facebook"
                          placeholder="https://www.facebook.com/---"
                          defaultValue={editInput.snsFacebook}
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setSnsFacebook(e.target.value);
                          }}
                          onBlur={validSnsFacebook}
                        />
                      </Grid>
                    </Grid>
                    <ValidationText message={errors.snsFacebookError} />
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item>
                        <CardMedia
                          component="img"
                          alt="Twitter"
                          height="24"
                          image="/images/icon_twitter.png"
                          title="Twitter"
                          className={[
                            classes.marginBottom10,
                            classes.hideMobile
                          ]}
                        />
                      </Grid>
                      <Grid item xs={12} sm container>
                        <TextField
                          label="Twitter"
                          placeholder="https://www.twitter.com/---"
                          defaultValue={editInput.snsTwitter}
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setSnsTwitter(e.target.value);
                          }}
                          onBlur={validSnsTwitter}
                        />
                      </Grid>
                    </Grid>
                    <ValidationText message={errors.snsTwitterError} />
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item>
                        <CardMedia
                          component="img"
                          alt="Instagram"
                          height="24"
                          image="/images/icon_instagram.png"
                          title="Instagram"
                          className={[
                            classes.marginBottom10,
                            classes.hideMobile
                          ]}
                        />
                      </Grid>
                      <Grid item xs={12} sm container>
                        <TextField
                          label="Instagram"
                          placeholder="https://www.instagram.com/---"
                          defaultValue={editInput.snsInstagram}
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setSnsInstagram(e.target.value);
                          }}
                          onBlur={validSnsInstagram}
                        />
                      </Grid>
                    </Grid>
                    <ValidationText message={errors.snsInstagramError} />
                  </div>
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="座席"
                  placeholder="カウンター○席、個室○室"
                  value={numberSit}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setNumberSit(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="禁煙/喫煙"
                  value={smoking}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setSmoking(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="駐車場"
                  placeholder="お店から徒歩○分に〇台"
                  value={parking}
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setParking(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
            </TableRow>
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <Typography className={classes.description}>
                    店舗詳細表示制限
                  </Typography>
                  <RadioGroup
                    row
                    value={stealthMode}
                    onChange={e => {
                      setStealthMode(e.target.value);
                      convertStealthModeStr(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="UNSTEALTH"
                      control={<Radio color="primary" />}
                      label="店舗詳細表示"
                    />
                    <FormControlLabel
                      value="STEALTH"
                      control={<Radio color="primary" />}
                      label="店舗詳細非表示"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.hideMobile} />
                <TableCell className={classes.colRight}>
                  非表示を選択した場合は、ごちめしアプリに店舗の詳細情報が表示されません。
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <Typography className={classes.description}>
                    誰でもごち制限
                  </Typography>
                  <RadioGroup
                    row
                    value={gochiRestriction}
                    onChange={e => {
                      setGochiRestriction(e.target.value);
                      convertGochiRestrictionStr(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="MENTION_ONLY"
                      control={<Radio color="primary" />}
                      label="指名ごちのみ"
                    />
                    <FormControlLabel
                      value="ANY"
                      control={<Radio color="primary" />}
                      label="制限なし"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.hideMobile} />
                <TableCell className={classes.colRight}>
                  指名ごちのみを選択した場合は、利用者を指名したごちのみ利用可能となります。
                </TableCell>
              </TableRow>
            )}
            {/* {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Typography className={classes.description}>
                    社食ごちめし現金授受の有無
                  </Typography>
                  <RadioGroup
                    row
                    value={cashAllowed}
                    onChange={e => {
                      const allowed = parseInt(e.target.value, 10);
                      setCashAllowed(allowed);
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="受け付けない"
                      disabled={!editInput.isShopCanEditSetting}
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="受け付ける"
                      disabled={!editInput.isShopCanEditSetting}
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )} */}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Typography className={classes.description}>
                    社食ごちめし金額指定チケット利用の有無
                  </Typography>
                  <RadioGroup
                    row
                    value={allowMenuPriceShashoku}
                    onChange={e => {
                      setAllowMenuPriceShashoku(parseInt(e.target.value, 0));
                    }}
                  >
                    <FormControlLabel
                      value={1}
                      disabled={!editInput.isShopCanEditSetting}
                      control={<Radio color="primary" />}
                      label="利用する"
                    />
                    <FormControlLabel
                      value={0}
                      disabled={!editInput.isShopCanEditSetting}
                      control={<Radio color="primary" />}
                      label="利用しない"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {/* {!roles.isShop && ( */}
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <Typography component="p" className={classes.description}>
                    売上受取方法
                  </Typography>
                  {!enableShopBank && (
                    <Typography className={classes.descriptionSmall}>
                      ※&nbsp;グループで銀行口座を管理しているため、入金管理の設定・表示を行うことはできません。
                    </Typography>
                  )}
                  <RadioGroup
                    value={depositManage}
                    onChange={e => {
                      setDepositManage(e.target.value);
                      convertDepositManageStr(e.target.value);
                    }}
                  >
                    <div className={classes.depositManageDiv}>
                      <FormControlLabel
                        value="SELF"
                        control={
                          <Radio
                            color="primary"
                            disabled={
                              !enableShopBank ||
                              editInput.accountStatus.stripeAccount
                            }
                          />
                        }
                        label="Stripe経由で受取（週1回入金）"
                      />
                      <Typography className={classes.subDescription}>
                        Stripe紐付けを行うことで、振込サイクルの変更や入金日のご確認ができるようになります
                      </Typography>
                    </div>
                    <div>
                      <FormControlLabel
                        value="NONSELF"
                        control={
                          <Radio
                            color="primary"
                            disabled={
                              !enableShopBank ||
                              editInput.accountStatus.stripeAccount
                            }
                          />
                        }
                        label="銀行口座で直接受取（月1回入金）（オプション）"
                      />
                      <Typography className={classes.subDescription}>
                        月末締め翌月5営業日以内に当社より振込みいたします（振込手数料は貴社負担）。
                        <br />
                        後から「自社で入金を管理する」へ変更することも可能です。
                      </Typography>
                    </div>
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {/* )} */}
            {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
              enableShopBank &&
              isLanguage === languageType.ORIGIN && (
                <>
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.hideMobile
                      ]}
                    />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        required
                        label="銀行コード"
                        defaultValue={editInput.bankCode}
                        disabled={!enableShopBank}
                        placeholder="0000"
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        onChange={e => {
                          handleChangeBankCode(e.target.value);
                        }}
                        onBlur={validBankCode}
                        inputProps={{
                          maxLength: 4,
                          inputMode: 'numeric'
                        }}
                      />
                      <Typography className={`${classes.font14}`}>
                        ※
                        <Link
                          href="https://zengin.ajtw.net/"
                          target="_blank"
                          className={classes.link}
                        >
                          検索サイト
                        </Link>
                      </Typography>
                      <Typography style={{ fontSize: 14 }}>
                        半角数字・4桁（3桁以下の方は、先頭に0をつけて4桁にしてください）
                      </Typography>
                      <ValidationText message={errors.bankCodeError} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.hideMobile
                      ]}
                    />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        label="銀行名"
                        defaultValue={editInput.bankName}
                        disabled
                        fullWidth
                        className={[classes.textField, classes.disableInput]}
                        margin="normal"
                        value={bankName}
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
            {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
              enableShopBank &&
              isLanguage === languageType.ORIGIN && (
                <>
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.hideMobile
                      ]}
                    />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        required
                        label="支店コード"
                        defaultValue={editInput.bankBranchCode}
                        disabled={!enableShopBank}
                        placeholder="000"
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        onChange={e => {
                          setBankBranchCode(e.target.value);
                          setBankBranchName('');
                        }}
                        onBlur={validBankBranchCode}
                        inputProps={{
                          maxLength: 3,
                          inputMode: 'numeric'
                        }}
                        value={bankBranchCode}
                      />
                      <Typography className={`${classes.font14}`}>
                        ※
                        <Link
                          href="https://zengin.ajtw.net/"
                          target="_blank"
                          className={classes.link}
                        >
                          検索サイト
                        </Link>
                      </Typography>
                      <Typography className={`${classes.font14}`}>
                        半角数字・3桁（2桁以下の方は、先頭に0をつけて3桁にしてください）
                      </Typography>
                      <ValidationText message={errors.bankBranchCodeError} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.hideMobile
                      ]}
                    />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        label="支店名"
                        defaultValue={editInput.bankBranchName}
                        disabled
                        fullWidth
                        className={[classes.textField, classes.disableInput]}
                        margin="normal"
                        value={bankBranchName}
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
            {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
              enableShopBank &&
              isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.hideMobile
                    ]}
                  />
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <Typography className={classes.description}>
                      口座種別
                    </Typography>
                    <RadioGroup
                      row
                      value={bankAccountType}
                      onChange={e => {
                        setBankAccountType(e.target.value);
                        convertBankAccountTypeStr(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="SAVINGS"
                        control={
                          <Radio color="primary" disabled={!enableShopBank} />
                        }
                        label="普通預金"
                      />
                      <FormControlLabel
                        value="CHECKING"
                        control={
                          <Radio color="primary" disabled={!enableShopBank} />
                        }
                        label="当座預金"
                      />
                    </RadioGroup>
                  </TableCell>
                </TableRow>
              )}
            {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
              enableShopBank &&
              isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.hideMobile
                    ]}
                  />
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      required
                      label="口座番号"
                      defaultValue={editInput.bankAccountNumber}
                      disabled={!enableShopBank}
                      placeholder="1234567"
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setBankAccountNumber(e.target.value);
                      }}
                      onBlur={validBankAccountNumber}
                    />
                    <ValidationText message={errors.bankAccountNumberError} />
                  </TableCell>
                </TableRow>
              )}
            {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
              enableShopBank &&
              isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.hideMobile
                    ]}
                  />
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
                  </TableCell>
                </TableRow>
              )}
            {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
              enableShopBank &&
              isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.hideMobile
                    ]}
                  />
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      required
                      label="口座名義"
                      defaultValue={editInput.bankAccountHolder}
                      disabled={!enableShopBank}
                      placeholder="ヤマダ　タロウ"
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setBankAccountHolder(e.target.value);
                      }}
                      onBlur={validBankAccountHolder}
                    />
                    <ValidationText message={errors.bankAccountHolderError} />
                  </TableCell>
                </TableRow>
              )}
            {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
              enableShopBank &&
              isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.hideMobile
                    ]}
                  />
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    必ず漢字/ひらがな以外でご記入ください。
                  </TableCell>
                </TableRow>
              )}
            {depositManage === 'SELF' &&
              enableShopBank &&
              isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.hideMobile
                    ]}
                  />
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <Divider />
                    <br />
                    第3者の決済サービス「Stripe&nbsp;Connect」を利用して頂く事で、自社で入金サイクル（基本は毎週）を変更したり、振込手数料を無料にする事ができます。こちらのオプションを選んだ場合は、以下の設定を行って頂きます。
                    <br />
                    <br />
                    ①&nbsp;Stripeでアカウントを作成する。
                    <br />
                    ②&nbsp;ごちめしを運営する当社のStripeアカウントに紐付けを行う。
                    <br />
                    ③&nbsp;初回入金時に、Stripe社より送られる案内メールにしたがって、本人確認資料を提出する。
                    <br />
                    <br />
                    管理画面左上の三本線メニューから、「その他」→「自社で入金管理（オプション）」を選んで頂くと、上記の①および②の設定が一度に行う事ができます。設定の詳細については、当管理システムのトップページから「ごちめし店舗登録マニュアルはこちら」をご参照ください。
                  </TableCell>
                </TableRow>
              )}
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openEditConfirm}>
          <ShopEditConfirm
            backAction={backAction}
            editAction={editAction}
            editConfirm={multiLangData}
            enableShopBank={enableShopBank}
            openEditProgress={openEditProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            roles={roles}
            otherData={otherData}
            currentLanguage={isLanguage}
            setIsLanguage={setIsLanguage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
